module.exports = __webpack_public_path__ + "img/ericssonnikolatesla.c00ee65a.jpg";